import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import { Locale } from 'vant';
// 引入语言包
import koKO from 'vant/es/locale/lang/ko-KO';
import jaJP from 'vant/es/locale/lang/ja-JP';
Locale.use('ko-KO', koKO);
Locale.use('ja-JP', jaJP);
// 设置Vant默认语言为日语（与i18n默认语言保持一致）
const defaultLang = localStorage.getItem('change-language') || 'jp';
if (defaultLang === 'jp') {
  Locale.use('ja-JP');
} else if (defaultLang === 'ko') {
  Locale.use('ko-KO');
}
import 'video.js/dist/video-js.css'
import i18n from './i18n';

import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";
import '@vant/touch-emulator';
Vue.use(VueDPlayer);


Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
